<template>
  <div class="awb-page">
    <div class="d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4">
      <div>
        <!-- Reached from Payments (Airwallex selected) only: no menu entry of its own. -->
        <router-link to="/payments?payment_mode=3" class="awb-muted small d-inline-block mb-1">{{ $t("airwallexBalance.crumb") }}</router-link>
        <h1 class="awb-title mb-0">{{ $t("airwallexBalance.title") }}</h1>
      </div>
      <div class="awb-toolbar">
        <template v-if="tab === 'overview'">
          <label class="awb-field">
            {{ $t("airwallexBalance.period") }}
            <select v-model="period" class="awb-select">
              <option v-for="option in periods" :key="option" :value="option">{{ $t("airwallexBalance." + option) }}</option>
            </select>
          </label>
          <template v-if="period === 'custom'">
            <label class="awb-field">
              {{ $t("airwallexBalance.from") }}
              <input v-model="customFrom" type="date" class="awb-input" :max="customTo" />
            </label>
            <label class="awb-field">
              {{ $t("airwallexBalance.to") }}
              <input v-model="customTo" type="date" class="awb-input" :min="customFrom" />
            </label>
          </template>
        </template>
        <label class="awb-field">
          {{ $t("airwallexBalance.account") }}
          <select v-model="branchId" class="awb-select">
            <option :value="null">{{ $t("airwallexBalance.allAccounts") }}</option>
            <option v-for="account in accounts" :key="account.airwallex_account_id" :value="account.physical_branch_id">
              {{ accountName(account) }}
            </option>
          </select>
          <span v-if="accounts.length > 1" class="awb-field__hint">{{ $t("airwallexBalance.walletNote") }}</span>
        </label>
      </div>
    </div>

    <nav class="awb-tabs mb-4" :aria-label="$t('airwallexBalance.title')">
      <button
        v-for="item in tabs"
        :key="item.id"
        type="button"
        class="awb-tab"
        :class="{ 'awb-tab--active': tab === item.id }"
        :aria-current="tab === item.id ? 'page' : null"
        @click="tab = item.id"
      >
        {{ $t(item.label) }}
      </button>
    </nav>

    <!-- v-show keeps each tab's filters and page when switching. -->
    <balance-overview
      v-show="tab === 'overview'"
      :branch-id="branchId"
      :period="period"
      :from="range[0]"
      :to="range[1]"
      @accounts="accounts = $event"
      @open="drawerId = $event"
      @show-transactions="showTransactions"
    />
    <balance-transactions
      v-show="tab === 'transactions'"
      ref="transactions"
      :branch-id="branchId"
      :multi-account="accounts.length > 1"
      @open="drawerId = $event"
    />

    <balance-transaction-drawer
      v-if="drawerId"
      :id="drawerId"
      @open="drawerId = $event"
      @close="drawerId = null"
    />
  </div>
</template>

<script>
import moment from "moment";
import BalanceOverview from "./airwallex-balance/BalanceOverview.vue";
import BalanceTransactions from "./airwallex-balance/BalanceTransactions.vue";
import BalanceTransactionDrawer from "./airwallex-balance/BalanceTransactionDrawer.vue";

export default {
  name: "airwallex-balance",
  components: { BalanceOverview, BalanceTransactions, BalanceTransactionDrawer },
  data() {
    return {
      tab: "overview",
      tabs: [
        { id: "overview", label: "airwallexBalance.overview" },
        { id: "transactions", label: "airwallexBalance.transactions" },
      ],
      // null = all of the merchant's accounts; else a physical_branch_id (0 = merchant level).
      branchId: null,
      accounts: [],
      drawerId: null,
      periods: ["last30", "thisMonth", "lastMonth", "past12", "custom"],
      period: "last30",
      customFrom: moment().subtract(29, "days").format("YYYY-MM-DD"),
      customTo: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    // [from, to] as Y-m-d for the Overview.
    range() {
      const today = moment();
      const days = {
        thisMonth: [today.clone().startOf("month"), today],
        lastMonth: [today.clone().subtract(1, "month").startOf("month"), today.clone().subtract(1, "month").endOf("month")],
        past12: [today.clone().subtract(11, "months").startOf("month"), today],
        custom: [moment(this.customFrom), moment(this.customTo)],
      }[this.period] || [today.clone().subtract(29, "days"), today];

      return days.map((day) => day.format("YYYY-MM-DD"));
    },
  },
  methods: {
    accountName(account) {
      return account.physical_branch_id
        ? account.branch_name || "#" + account.physical_branch_id
        : this.$t("airwallexBalance.merchantAccount");
    },
    showTransactions(category) {
      this.$refs.transactions.filterBy(category);
      this.tab = "transactions";
    },
  },
};
</script>

<style lang="scss">
@import "./airwallex-balance/balance.scss";
</style>
